module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIII",
      "title": "XIII"
    }
  }, [_c('h1', {
    staticClass: "pre_surtit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fond_2",
      "src": "images/fond.jpg"
    }
  })])]), _c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("ABBREVIATIONS")])]), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "p13"
    }
  }, [_c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    staticStyle: {
      "border-collapse": "collapse",
      "border-spacing": "0px"
    }
  }, [_c('colgroup', {
    staticStyle: {
      "padding": "1px"
    }
  }, [_c('col', {
    staticStyle: {
      "width": "18%"
    }
  }), _c('col', {
    staticStyle: {
      "padding": "1px"
    }
  })]), _c('tbody', [_c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("AOAT")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Alter Orient und Altes Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("AUSS")])])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Andrews University Seminary Studies")])])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("BDAG")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Greek-English Lexicon of the New Testament and Other Early Christian Literature")]), _vm._v(". Frederick W. Danker, Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. 3rd ed. Chicago: University of Chicago Press, 2000 (Bauer-Danker-Arndt-Gingrich)")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("BECNT")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Baker Exegetical Commentary on the New Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("BZNW")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Beihefte zur Zeitschrift für die neutestamentliche Wissenschaft")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("CBQ")])])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Catholic Biblical Quarterly")])])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("COS")])])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("The Context of Scripture")]), _vm._v(". Edited by William W. Hallo. 3 vols. Leiden: Brill, 1997–2002")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("IBC")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Interpretation: A Bible Commentary for Teaching and Preaching")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("JETS")])])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("JSOTSup")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("JTISup")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Journal for Theological Interpretation, Supplements")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("NICNT")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("New International Commentary on the New Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("NICOT")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("New International Commentary on the Old Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("NovTSup")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Supplements to Novum Testamentum")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XIV",
      "title": "XIV"
    }
  }, [_vm._v("NSBT")])])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("New Studies in Biblical Theology")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("PNTC")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Pillar New Testament Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("TJ")])])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Trinity Journal")])])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("VTSup")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("WBC")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Word Biblical Commentary")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("WCF")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Westminster Confession of Faith")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("WUNT")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Wissenschaftliche Untersuchungen zum Neuen Testament")])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("ZAW")])])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('i', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])]), _c('tr', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("ZECNT")])]), _c('td', {
    staticStyle: {
      "padding": "1px",
      "vertical-align": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Zondervan Exegetical Commentary on the New Testament")])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30ed1363","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre4.vue
// module id = 72
// module chunks = 0